import Button from "@material-ui/core/Button";
import green from "@material-ui/core/colors/green";
import Dialog from "@material-ui/core/Dialog";
import { withStyles, useTheme } from "@material-ui/core/styles";
import React, { useState, useEffect, useRef, useMemo, createRef } from "react";
import { postAxios } from "../../api/Axios";
import { notificationApi } from "../../api/Urls";
import classes from "./AddMission.module.scss";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import toFarsiNumber from "util/toFarsiNumber";
import Checkbox from "@material-ui/core/Checkbox";
import "leaflet/dist/leaflet.css";
import ChangeView from "./ChangeView";
import { MapContainer as Map, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import { FormControlLabel } from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../tabPanel/TabPanel";

const styles = (theme) => ({
  buttonProgress: {
    color: green[500],
  },
});

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: require("../../assets/images/marker-icon.png"),
  shadowUrl: require("../../assets/images/marker-shadow.png"),
});

const GreenCheckbox = withStyles({
  root: {
    color: "#3f51b5",
    "&$checked": {
      color: "#3f51b5",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const AddMission = ({
  setRefreshData,
  groupData,
  setGroupData,
  groupReceivers,
  setGroupReceivers,
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [mapCenter, setMapCenter] = useState([35.67, 51.4]);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [isNeedLocation, setIsNeedLocation] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [messageValues, setMessageValues] = useState({
    title: "",
    messageText: "",
  });
  const [elRefs, setElRefs] = useState([]);
  const markerRef = useRef(null);
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setMapCenter(marker.getLatLng());
        }
      },
    }),
    []
  );

  useEffect(() => {
    // add or remove refs
    setElRefs((elRefs) =>
      Array(groupData?.length)
        .fill()
        .map((_, i) => elRefs[i] || createRef())
    );
  }, [groupData?.length]);

  const handleRequestClose = () => {
    setOpen(false);
    setMessageValues({
      title: "",
      messageText: "",
    });
    setGroupReceivers(groupData.slice().fill(false));
    setGroupData(
      groupData.map((group) => {
        return {
          ...group,
          checked: false,
        };
      })
    );
  };

  const handleChangeInputs = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox" ? target.checked : toFarsiNumber(target.value);
    const name = target.name;
    if (name === "title" && value.length <= 128) {
      setMessageValues({ ...messageValues, [name]: value });
    }
    if (name === "messageText" && value.length <= 1024) {
      setMessageValues({ ...messageValues, [name]: value });
    }
  };

  const handleSubmitMessage = () => {
    let finalData = new FormData();
    finalData.append("type", 2);
    finalData.append("subject", messageValues.title);
    finalData.append("message", messageValues.messageText);
    const groupUuid = groupData.filter(
      (group, i) => groupReceivers[i] && group.uuid
    );
    for (const i of groupUuid) {
      finalData.append("groups", i.uuid);
    }
    if (isNeedLocation) {
      finalData.append(
        "meta",
        JSON.stringify({
          lat: mapCenter.lat || mapCenter[0],
          long: mapCenter.lng || mapCenter[1],
        })
      );
    } else {
      finalData.append("meta", JSON.stringify({}));
    }
    postAxios(`${notificationApi}`, finalData)
      .then((data) => {
        if (data.status === 200) {
          handleRequestClose();
          enqueueSnackbar(data.data.message, {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
          setIsNeedLocation(false);
          setMapCenter([35.67, 51.4]);
          setRefreshData((prev) => !prev);
        }
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  useEffect(() => {
    checkMessageValidation();
  }, [messageValues]);

  const checkMessageValidation = () => {
    setDisableSubmit(
      messageValues.title && messageValues.messageText ? false : true
    );
  };

  const handleChangeLastCheckpoint = (e) => {
    setIsNeedLocation(e.target.checked);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const groupCheckboxHandleChange = (index) => (event) => {
    const newAllSubs = [...groupData];
    newAllSubs[index].checked =
      event.target.checked === undefined
        ? !elRefs[index].current.children[0].children[0].checked
        : event.target.checked;
    setGroupData(newAllSubs);
    setGroupReceivers(groupReceivers.map((v, i) => (i === index ? !v : v)));
  };

  return (
    <>
      <div className={classes.root}>
        <Button
          variant="contained"
          className="btn btn-primary jr-btn-uptin"
          onClick={() => setOpen(true)}
        >
          <span>{t("missions.new_mission")}</span>
        </Button>
        <Dialog
          open={open}
          onClose={handleRequestClose}
          className={classes.dialogRoot}
          maxWidth="md"
          fullWidth
        >
          <div className={`${classes.modalContainer} text-center`}>
            <div>
              <h2 className="m-1">{t("missions.new_mission")}</h2>
              <div className={classes.formContainer}>
                <div className={classes.topFormContainer}>
                  <div className={classes.messageContainer}>
                    <div
                      className={
                        i18n.language === "fa"
                          ? classes.outlinedInputRtl
                          : classes.outlinedInputLtr
                      }
                    >
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="title"
                          onChange={(event) => handleChangeInputs(event)}
                          value={messageValues.title}
                          startAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("missions.message_title")}
                              </InputAdornment>
                            )
                          }
                          endAdornment={
                            i18n.language === "en" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("missions.message_title")}
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>

                    <div
                      className={
                        i18n.language === "fa"
                          ? classes.outlinedInputRtlTextarea
                          : classes.outlinedInputLtrTextarea
                      }
                    >
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="messageText"
                          multiline
                          minRows={8}
                          onChange={(event) => handleChangeInputs(event)}
                          value={messageValues.messageText}
                          startAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("missions.message_text")}
                              </InputAdornment>
                            )
                          }
                          endAdornment={
                            i18n.language === "en" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("missions.message_text")}
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>
                    <FormControlLabel
                      className={
                        i18n.language === "fa"
                          ? classes.checkboxContainerRtl
                          : classes.checkboxContainerLtr
                      }
                      control={
                        <GreenCheckbox
                          checked={isNeedLocation}
                          onChange={(event) =>
                            handleChangeLastCheckpoint(event)
                          }
                          name="are_guideline_accepted"
                        />
                      }
                      label={<p>{t("missions.is_need_location")}</p>}
                    />
                  </div>
                  <div className={classes.mainListContainer}>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        // variant="fullWidth"
                        aria-label="full width tabs example"
                        style={{
                          direction: i18n.language === "en" ? "ltr" : "rtl",
                        }}
                      >
                        <Tab
                          label={t("notifications.group_tab_title")}
                          {...a11yProps(0)}
                        />
                      </Tabs>
                    </AppBar>
                    <SwipeableViews
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={tabValue}
                      onChangeIndex={handleChangeIndex}
                      style={{
                        padding: 0,
                        backgroundColor: "#e7ecf4",
                        borderRadius: "1em",
                      }}
                    >
                      <TabPanel
                        value={tabValue}
                        index={0}
                        dir={theme.direction}
                      >
                        <div className={` ${classes.listContainer}`}>
                          <ul className={classes.ulList}>
                            {groupData.length > 0 &&
                              groupData.map((s, index) => (
                                <li
                                  style={{
                                    flexDirection:
                                      i18n.language === "en"
                                        ? "row-reverse"
                                        : "row",
                                  }}
                                  className={`${classes.liList} ${
                                    s.checked === true
                                      ? classes.liListSelected
                                      : ""
                                  } groups-users--user`}
                                  key={s.pk + Math.random()}
                                  onClick={groupCheckboxHandleChange(index)}
                                >
                                  <span>{s.title}</span>
                                  <span className="userInGroup-step-one">
                                    <Checkbox
                                      ref={elRefs[index]}
                                      color="primary"
                                      checked={s?.checked}
                                      onChange={groupCheckboxHandleChange(
                                        index
                                      )}
                                    />
                                  </span>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </TabPanel>
                    </SwipeableViews>
                  </div>
                </div>
                {isNeedLocation && (
                  <div className={classes.mapContainer}>
                    <div className="user-leaf-map-container">
                      <Map
                        center={mapCenter}
                        zoom={13}
                        className="user-leaf-map"
                      >
                        <ChangeView center={mapCenter} zoom={13} />
                        <TileLayer
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker
                          draggable={true}
                          eventHandlers={eventHandlers}
                          position={mapCenter}
                          ref={markerRef}
                        ></Marker>
                      </Map>
                    </div>
                  </div>
                )}
              </div>
              <Button
                variant="contained"
                className="btn btn-primary jr-btn-uptin"
                onClick={() => handleSubmitMessage()}
                disabled={disableSubmit}
              >
                <span>{t("missions.send_mission")}</span>
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default withStyles(styles)(AddMission);
